import { render, staticRenderFns } from "./PlayAvatar.vue?vue&type=template&id=1f993057&scoped=true"
import script from "./PlayAvatar.vue?vue&type=script&lang=js"
export * from "./PlayAvatar.vue?vue&type=script&lang=js"
import style0 from "./PlayAvatar.vue?vue&type=style&index=0&id=1f993057&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f993057",
  null
  
)

export default component.exports